module.exports = __webpack_public_path__ + "static/Grafika3@2x-da332e98d78936bf2538d29f326dd417.png";